const durationFormatter = new Intl.DurationFormat(undefined, {
	style: 'short',
});

/**
 * Outputs a given ms value as human readable string
 * For example:
 * 	750 -> 750ms
 * 	1250 -> 1.25s
 * 	61_250 -> 1m 1.25s
 * 	3_661_250 -> 1h 1m 1.25s
 */
export function formatDuration(ms: number) {
	const value = Math.round(ms);

	if (value <= 1000) {
		return durationFormatter.format({ milliseconds: value });
	}

	const hours = Math.floor(value / 3_600_000);
	const minutes = Math.floor((value % 3_600_000) / 60_000);
	const seconds = Math.floor((value % 60_000) / 1000);
	const milliseconds = value % 1000;

	return durationFormatter.format({ hours, minutes, seconds, milliseconds });
}
